export enum MentionsApiErrorEnum {
    folderLimitReached = 'ADVMON-001' // Folder reached the maximum number of mentions
}
